export enum SalesConciergeProductCount {
    LESS_THAN_50 = '< 50',
    NO_INFORMATION = 'Keine Angabe',
    MORE_THAN_50 = '50 +'
}

